export default {
  country: 'Land',
  language: 'Sprache',
  currency: 'Währung',
}
